import React, { useEffect, useState } from "react";
import "./GroupLoansAppliedToLoans.scss";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography, CircularProgress } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import CloseIcon from "@mui/icons-material/Close";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import GroupLoansViewLateFees from "../GroupLoansViewLateFees/GroupLoansViewLateFees";
import GroupLoansViewPayments from "../GroupLoansViewPayments/GroupLoansViewPayments";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansAppliedToLoans = ({ selectedPayment, setLoansListView, selectedMemberName }) => {
    const [loansArray, setLoansArray] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [appliedLoansView, setAppliedLoansView] = useState(null);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    
    useEffect(()=>{
        console.log("GroupLoansAppliedToLoans------------",selectedPayment?.loanpayments?.paymentid)
        getAppliedLoans();
    },[selectedPayment]);

    const getAppliedLoans = async() => {
        try {
            const response = await commonRunQuery(293, selectedPayment?.loanpayments?.paymentid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loansArr = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setLoansArray(loansArr);
              console.log("getAppliedLoans_response==========",loansArr);
            } else {
                setLoansArray([]);
            }
        } catch (error) {
            console.log("getAppliedLoans_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            label: 'Apply Id',
            getValue: (row) => row?.loanapplied?.applyid ?? ''
        },
        {
            label: 'Amount Applied',
            getValue: (row) => row?.loanapplied?.amountapplied  ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Confirmation Time',
            getValue: (row) => row?.loanapplied?.confirmationtime ?? ''
        },
        {
            label: 'Fees Applied',
            getValue: (row) => row?.loanapplied?.feesapplied ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Status',
            getValue: (row) => row?.loanapplied?.status === "1" ? "Confirmed" : "Not Confirmed"
        }
    ];

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    return (
        <Box>
            {
                appliedLoansView == null && <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                        List Of Payment Applied Loans - {selectedMemberName}
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setLoansListView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

            {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                ) :
                (
                    <>
                        {
                            appliedLoansView == null && <Box className="mt-4">
                                <GroupLoansTable
                                    data={loansArray} 
                                    columns={columns} 
                                    title="List of Loans" 
                                    formatRow={(row) => [
                                        row.id,
                                        row.record?.BorrowerName,
                                        row.name,
                                        row.balance,
                                        row.record?.DaysPastDue,
                                        row.record?.AmountDue
                                    ]} 
                                    viewMenu={true}
                                    handleMenuOpen={handleMenuOpen}
                                    downloads={false}
                                    // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                                />
                            </Box>
                        }
                    </>
                )
            }

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="75vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedLoan && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                    {/* Left Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Loan ID", value: selectedLoan?.loanapplied?.loanid },
                                            { label: "User ID", value: selectedLoan?.loanapplied?.userid },
                                            { label: "Payment ID", value: selectedLoan?.loanapplied?.paymentid },
                                            { label: "Confirmation Time", value: selectedLoan?.loanapplied?.confirmationtime },
                                            { label: "Confirmation Ref No", value: selectedLoan?.loanapplied?.confirmationrefno || "N/A" },
                                            { label: "Currency Code", value: selectedLoan?.loanapplied?.currcode },
                                            { label: "Payment Plan ID", value: selectedLoan?.loanapplied?.paymentplanid || "N/A" },
                                            { label: "Status", value: selectedLoan?.loanapplied?.status === "1" ? "Confirmed" : "Not Confirmed" },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value || "N/A"}</Box>
                                            </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Amount Applied", value: selectedLoan?.loanapplied?.amountapplied },
                                            { label: "Fees Applied", value: selectedLoan?.loanapplied?.feesapplied },
                                            { label: "Total Amount Applied", value: selectedLoan?.loanapplied?.totalamountapplied },
                                            { label: "Tax Amount Breakdown", value: selectedLoan?.loanapplied?.taxamountbreakdown },
                                            { label: "Fee System Breakdown", value: selectedLoan?.loanapplied?.feesystembreakdown },
                                            { label: "Fee External Breakdown", value: selectedLoan?.loanapplied?.feeexternalbreakdown },
                                            { label: "Fee Franchisee Breakdown", value: selectedLoan?.loanapplied?.feefranchiseebreakdown },
                                            { label: "Fee Reseller Breakdown", value: selectedLoan?.loanapplied?.feeresellerbreakdown },
                                            { label: "Payment Date", value: selectedLoan?.loanpayments?.paymentdate },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">
                                                    {value ? Number(value).toLocaleString() : "N/A"}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="sm"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Loan Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedLoan && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Loan ID", value: selectedLoan?.loanapplied?.loanid },
                                                { label: "User ID", value: selectedLoan?.loanapplied?.userid },
                                                { label: "Payment ID", value: selectedLoan?.loanapplied?.paymentid },
                                                { label: "Confirmation Time", value: selectedLoan?.loanapplied?.confirmationtime },
                                                { label: "Confirmation Ref No", value: selectedLoan?.loanapplied?.confirmationrefno || "N/A" },
                                                { label: "Currency Code", value: selectedLoan?.loanapplied?.currcode },
                                                { label: "Payment Plan ID", value: selectedLoan?.loanapplied?.paymentplanid || "N/A" },
                                                { label: "Status", value: selectedLoan?.loanapplied?.status === "1" ? "Confirmed" : "Not Confirmed" },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value || "N/A"}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Amount Applied", value: selectedLoan?.loanapplied?.amountapplied },
                                                { label: "Fees Applied", value: selectedLoan?.loanapplied?.feesapplied },
                                                { label: "Total Amount Applied", value: selectedLoan?.loanapplied?.totalamountapplied },
                                                { label: "Tax Amount Breakdown", value: selectedLoan?.loanapplied?.taxamountbreakdown },
                                                { label: "Fee System Breakdown", value: selectedLoan?.loanapplied?.feesystembreakdown },
                                                { label: "Fee External Breakdown", value: selectedLoan?.loanapplied?.feeexternalbreakdown },
                                                { label: "Fee Franchisee Breakdown", value: selectedLoan?.loanapplied?.feefranchiseebreakdown },
                                                { label: "Fee Reseller Breakdown", value: selectedLoan?.loanapplied?.feeresellerbreakdown },
                                                { label: "Payment Date", value: selectedLoan?.loanpayments?.paymentdate },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">
                                                        {value ? Number(value).toLocaleString() : "N/A"}
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog> */}
            
        </Box>
    )

}

export default GroupLoansAppliedToLoans;
